import React from "react";
import classes from "./Docs.module.css";
import QR from "../../Asset/QR.png";
import foodbar from "../../Asset/foodbar.png";
const Docs = () => {
    return (
        
        <div className={classes.container}>
            <div className={classes.headerWrapper}>
                <header className={classes.header}>
                    <div className={classes.headerLeft}>
                        <h1>Invoice</h1>
                    </div>
                    <div className={classes.headerCenter}>
                        <p>
                            <strong>Foobar Labs</strong><br />
                            4d, Raghavendr Dham Society<br />
                            Surat, Gujarat, India - 394210
                        </p>
                    </div>
                    <div className={classes.headerRight}>
                      <img src={foodbar} alt="Foobar Labs" />
                        <h2>Foobar Labs</h2>
                    </div>
                </header>
            </div>

            <div className={classes.detailsSection}>
                <div className={classes.billed}>
                    <h4>Billed To</h4>
                    <p>
                        Studio Den<br />
                        305, 3rd Floor Orion mall, Bengaluru,<br />
                        Karnataka, India - 560055<br />
                        <strong>GST:</strong> 29VCUDE1234KZ26<br />
                        <strong>PAN:</strong> VOCEDE1234K
                    </p>
                </div>

                <div className={classes.invoiceDetails}>
                    <h4>Invoice Details</h4>
                    <p><strong>Invoice #:</strong> 003</p>
                    <p><strong>Invoice Date:</strong> FEB 19, 2020</p>
                    <p><strong>Due Date:</strong> FEB 19, 2020</p>
                </div>

                <div className={classes.paymentRecord}>
                    <h4>Payment Record</h4>
                    <p><strong>Paid Amount:</strong> ₹0</p>
                    <p><strong>Due Amount:</strong> ₹36,000</p>
                </div>
            </div>

            {/* ITEMS TABLE */}
            <table className={classes.table}>
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>HSN</th>
                        <th>Qty.</th>
                        <th>GST</th>
                        <th>Taxable Amount</th>
                        <th>SGST</th>
                        <th>CGST</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {[
                        'Basic Web Development',
                        'Logo Design',
                        'Web Design',
                        'Full Stack Web Development'
                    ].map((item, idx) => (
                        <tr key={idx}>
                            <td>{item}</td>
                            <td>06</td>
                            <td>1</td>
                            <td>9%</td>
                            <td>₹10,000.00</td>
                            <td>₹900</td>
                            <td>₹900</td>
                            <td>₹11,800.00</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={classes.summarySection}>
                <div className={classes.leftSummary}>
                    <p><strong>Country of Supply:</strong> India</p>
                    <p><strong>Place of Supply:</strong> Gujarat</p>
                </div>
                <div className={classes.rightSummary}>
                    <p><span>Sub Total:</span><span>₹40,000</span></p>
                    <p><span>Discount:</span><span> (10%) ₹4,000</span></p>
                    <p><span>Taxable Amount:</span><span>₹36,000</span></p>
                    <p><span>SGST:</span><span>₹3240</span></p>
                    <p><span>CGST:</span><span>₹3240</span></p>
                    <h3><span>Total Due:</span><span>₹36,000</span></h3>
                </div>
                <p className={classes.inWords}><strong>Invoice Total in Words:</strong> Forty Two thousand Four Hundred and Eighty</p>
            </div>


            {/* FOOTER */}
            <section className={classes.footer}>


                {/* PAYMENTS HISTORY */}
                <div className={classes.history}>
                    <h4>Payments</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Mode</th>
                                <th>Status</th>
                                <th>Amount</th>
                                <th>Transaction Charge</th>
                                <th>TDS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>May 06, 2020</td>
                                <td>Net Banking</td>
                                <td className={classes.approved}>Approved</td>
                                <td>₹3,000</td>
                                <td>₹0</td>
                                <td>₹0</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className={classes.grid}>
                    <div>
                        <h4>Terms and Conditions</h4>
                        <ul>
                            <li>Please pay within 15 days from the date of invoice. Overdue interest @ 14% will be charged on delayed payments.</li>
                            <li>Please quote invoice number when remitting funds.</li>
                        </ul>

                        <div className={classes.additionalNotes}>
                            <h4>Additional Notes</h4>
                            <p>
                                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.
                            </p>
                        </div>

                        <div className={classes.contact}>
                            For any enquiries, email us on <strong>foobarlabs@gmail.com</strong> or call us on <strong>+91 98760 44329</strong>
                        </div>
                    </div>

                    <div className={classes.bankDetails}>
                        <h4>Bank & Payment Details</h4>
                        <p><strong>Account Holder Name:</strong> Foobar Labs</p>
                        <p><strong>Account Number:</strong> 45364287897</p>
                        <p><strong>IFSC:</strong> SBIN0018519</p>
                        <p><strong>Account Type:</strong> Savings</p>
                        <p><strong>Bank:</strong> State Bank of India</p>
                        <div className={classes.upiRow}>
                            <p><strong>UPI:</strong> foobarlabs@sbi</p>
                            <img src={QR} className={classes.QR} alt="Logo" />

                        </div>
                    </div>
                </div>

            </section>
        </div>
    );
};

export default Docs;
